import request from './request';
import { toSearchQuery } from './helpers';

export default {
  messages: (startDate, endDate) =>
    request.get(
      `/messages-analytic?${toSearchQuery({
        startDate,
        endDate
      })}`
    ),
  customers: (startDate, endDate) =>
    request.get(
      `/messages-analytic/customers?${toSearchQuery({
        startDate,
        endDate
      })}`
    ),
  general: (startDate, endDate) =>
    request.get(
      `/messages-analytic/general?${toSearchQuery({
        startDate,
        endDate
      })}`
    ),
  message: (id, startDate, endDate) =>
    request.get(
      `/messages-analytic/${id}?${toSearchQuery({
        startDate,
        endDate
      })}`
    ),
  customer: (id, startDate, endDate) =>
    request.get(
      `/messages-analytic/customers/${id}?${toSearchQuery({
        startDate,
        endDate
      })}`
    )
};
